module.exports = __webpack_public_path__ + "img/9788952705693.5849e083.jpg";